/**
 * 系统全局配置业务层 — 对接 Apifox scj 系统全局配置 Controller
 */

import { configService } from '@/services/artApi';
import { unwrapApiList, unwrapApiResult, mapConfigDtoToRecord } from '@/utils/artMapper';

const PRINT_KEY_PREFIX = 'print.';
const PRINT_KEY_DESC = {
  bleedMm: '出血（mm）',
  diecutInsetMm: '刀版内缩（mm）',
  dpi: '输出 DPI',
};

export async function fetchSystemConfigList() {
  const payload = await configService.getList();
  return unwrapApiList(payload).map(mapConfigDtoToRecord);
}

export async function fetchSystemConfig(configKey) {
  const payload = await configService.get(configKey);
  return mapConfigDtoToRecord(unwrapApiResult(payload) || {});
}

export async function saveSystemConfig(configKey, configValue, configDesc = '') {
  const payload = await configService.save({
    configKey,
    configValue: configValue == null ? '' : String(configValue),
    configDesc: configDesc || '',
  });
  return mapConfigDtoToRecord(unwrapApiResult(payload) || {});
}

/** 将远程配置写入 platform.printConfig.global */
export function applyPrintConfigsToPlatform(platform, records = []) {
  if (!platform.printConfig) platform.printConfig = { global: {}, stores: {} };
  if (!platform.printConfig.global) platform.printConfig.global = {};
  records.forEach(({ key, value }) => {
    if (!key || !key.startsWith(PRINT_KEY_PREFIX)) return;
    const field = key.slice(PRINT_KEY_PREFIX.length);
    if (!(field in platform.printConfig.global) && !['bleedMm', 'diecutInsetMm', 'dpi'].includes(field)) {
      return;
    }
    const num = Number(value);
    platform.printConfig.global[field] = Number.isFinite(num) ? num : value;
  });
}

export async function syncSystemConfigLibrary(platform) {
  const records = await fetchSystemConfigList();
  applyPrintConfigsToPlatform(platform, records);
  return records;
}

/** 保存印刷参数到远程（按 configKey 逐项 upsert） */
export async function savePrintConfigRemote(cfg = {}) {
  const entries = Object.entries(cfg).filter(([key]) => ['bleedMm', 'diecutInsetMm', 'dpi'].includes(key));
  const saved = [];
  for (const [field, value] of entries) {
    const record = await saveSystemConfig(
      `${PRINT_KEY_PREFIX}${field}`,
      value,
      PRINT_KEY_DESC[field] || field,
    );
    saved.push(record);
  }
  return saved;
}
